export default __webpack_public_path__ + "static/media/opinion-2.5e32a579.svg";